<script>
import { hmdaMethods } from '@state/helpers'
import { hmdaACL } from '@/src/utils/accesslevels'
export default {
  props: {
    crumbs: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      customer: null,
      user: null,
      isShowCustomer: false,
    }
  },
  mounted() {
    hmdaACL.initializeAccessControls()
    this.isShowCustomer = hmdaACL.canSelectCustomer()

    this.getSelectedCustomer().then((res) => {
      this.customer = res
    })

    this.getSelectedUser().then((res) => {
      this.user = res
    })
  },

  methods: {
    ...hmdaMethods,
  },
}
</script>

<template>
  <div class="body--wrapper mt-1 container p-0">
    <b-row align-v="center" no-gutters>
      <b-col>
        <BaseBreadcrumb :crumbs="crumbs" />
      </b-col>
      <b-col v-if="isShowCustomer" class="text-right">
        On behalf of :
        <span class="font-weight-bold">
          {{ customer ? customer.text : '-' }} /
          {{ user ? user.text : '-' }}
        </span>
      </b-col>
    </b-row>
  </div>
</template>
